import React, { useContext } from 'react'
import { LuFilter, LuX } from 'react-icons/lu'
import SessionContext from '../../context/SessionContex'
import FilterContext from '../../context/FilterContext'
import utils from '../../utils'

function SideBar(props) {
    const sessionCtx = useContext(SessionContext)
    const categories = sessionCtx.categories
    const filterCtx = useContext(FilterContext)
    const houseCategory = filterCtx.houseCategory
    const houseRooms = filterCtx.houseRooms
    const { storiesParam, bathroomsParam } = props

    const roomNames = utils.roomNames
    const stories = utils.stories
    const bathrooms = utils.bathrooms

    const FilterSection = ({ title, isOpen, children }) => (
        <div className="collapse collapse-arrow bg-transparent border-b border-outline-variant/10 rounded-none">
            <input type="checkbox" defaultChecked={isOpen} />
            <div className="collapse-title px-0 py-4 font-black text-[10px] uppercase tracking-[0.2em] text-on-surface">
                {title}
            </div>
            <div className="collapse-content px-0">
                <div className="flex flex-col gap-2 pb-4">
                    {children}
                </div>
            </div>
        </div>
    )

    const FilterItem = ({ label, active, onClick, onClear }) => (
        <div
            onClick={onClick}
            className={`
                group flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all
                ${active
                    ? 'bg-primary text-white shadow-md shadow-primary/20'
                    : 'hover:bg-primary/5 text-on-surface-variant hover:text-primary'}
            `}
        >
            <span className={`text-sm ${active ? 'font-black' : 'font-medium'}`}>{label}</span>
            {active && (
                <LuX
                    className="hover:scale-125 transition-transform"
                    onClick={(e) => { e.stopPropagation(); onClear(); }}
                />
            )}
        </div>
    )

    return (
        <div className='hidden md:flex md:w-4/12 lg:w-1/4'>
            <div className="sticky top-24 w-full self-start">
                <div className="bg-white rounded-2xl p-6 border border-outline-variant/50 shadow-sm bg-primary/10">
                    <div className="flex items-center gap-3 mb-8">
                        <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center text-white shadow-lg shadow-primary/20">
                            <LuFilter size={20} />
                        </div>
                        <h2 className="font-headline font-black text-xl text-on-surface tracking-tight">
                            Filter Plans
                        </h2>
                    </div>

                    <FilterSection title="Building Style" isOpen={!!houseCategory}>
                        {categories.map((category, idx) => (
                            <FilterItem
                                key={idx}
                                label={category?.name}
                                active={houseCategory === category?.slug}
                                onClick={() => props.changeCategoryParam(category?.slug)}
                                onClear={() => props.changeCategoryParam()}
                            />
                        ))}
                    </FilterSection>

                    <FilterSection title="Bedrooms" isOpen={!!houseRooms}>
                        {roomNames.map((room, idx) => (
                            <FilterItem
                                key={idx}
                                label={room?.name}
                                active={houseRooms === room?.value}
                                onClick={() => props.changeRoomsParam(room?.value)}
                                onClear={() => props.changeRoomsParam(0)}
                            />
                        ))}
                    </FilterSection>

                    <FilterSection title="Stories" isOpen={!!storiesParam}>
                        {stories.map((story, idx) => (
                            <FilterItem
                                key={idx}
                                label={story?.name}
                                active={parseInt(storiesParam) === story?.value}
                                onClick={() => props.changeStoriesParam(story?.value)}
                                onClear={() => props.changeStoriesParam(0)}
                            />
                        ))}
                    </FilterSection>

                    <FilterSection title="Bathrooms" isOpen={!!bathroomsParam}>
                        {bathrooms.map((bathroom, idx) => (
                            <FilterItem
                                key={idx}
                                label={bathroom?.name}
                                active={parseInt(bathroomsParam) === bathroom?.value}
                                onClick={() => props.changeBathroomsParam(bathroom?.value)}
                                onClear={() => props.changeBathroomsParam(0)}
                            />
                        ))}
                    </FilterSection>

                    <div className="mt-8 pt-6 border-t border-outline-variant/10">
                        <button
                            onClick={() => {
                                props.changeCategoryParam();
                                props.changeRoomsParam(0);
                                props.changeStoriesParam(0);
                                props.changeBathroomsParam(0);
                            }}
                            className="w-full py-3 text-[10px] font-black uppercase tracking-widest text-on-surface-variant hover:text-error transition-colors"
                        >
                            Reset All Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SideBar